export default __webpack_public_path__ + "static/media/auth-bg-2.8373d6b4.png";